var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Collapse from 'antd/lib/collapse';
import { Icon } from '@ant-design/compatible';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import { polyfill } from 'react-lifecycles-compat';
import TweenOne from 'rc-tween-one';
import AutoComplete from './common/AutoComplete';
import SelectInput from './common/SelectInput';
import { getOption, getOptionArray, getRandomKey, removeMultiEmpty } from '../utils';
var Panel = Collapse.Panel;
var TweenOneGroup = TweenOne.TweenOneGroup;
var nameSource = ['all', 'transform', 'background', 'border', 'color',
    'opacity', 'width', 'height', 'margin', 'padding', 'top', 'right',
    'bottom', 'left', 'box-shadow', 'text-shadow'];
var easeSource = {
    ease: '缓动',
    'ease-in': '前',
    'ease-out': '后',
    'ease-in-out': '前后',
    'cubic-bezier(0.08, 0.82, 0.17, 1)': 'circ 后',
    'cubic-bezier(0.6, 0.04, 0.98, 0.34)': 'circ 前',
    'cubic-bezier(0.78, 0.14, 0.15, 0.86)': 'circ 前后',
};
var EditorTransition = /** @class */ (function (_super) {
    __extends(EditorTransition, _super);
    function EditorTransition(props) {
        var _this = _super.call(this, props) || this;
        _this.onClick = function () {
            var data = _this.state.data;
            data.push({ key: getRandomKey() });
            _this.setState({
                data: data,
            });
        };
        _this.onChange = function (key, i, value) {
            var data = _this.state.data;
            var currentData = data[i];
            currentData[key] = value;
            _this.setData(data);
        };
        _this.setData = function (data) {
            _this.setState({
                data: data,
            }, function () {
                var value = data.length ? '' : 'none';
                data.forEach(function (d) {
                    if (d.name) {
                        value += "" + (value ? ', ' : '') + removeMultiEmpty(d.name + " " + (d.duration || '0s') + " " + (d.ease || 'ease') + (d.delay ? " " + d.delay : ''));
                    }
                });
                if (value) {
                    value += ';';
                }
                _this.props.onChange('transition', value);
            });
        };
        _this.getStateData = function (props, prevData) {
            if (prevData === void 0) { prevData = []; }
            var values = props.value.split(/,\s?(?=[a-z])/g).map(function (c) { return c.trim(); });
            var data = values.filter(function (str) {
                return (str && str !== 'all 0s ease 0s' && str !== 'all 0s ease');
            })
                .map(function (str, i) {
                if (str.replace(/;/g, '') === 'none') {
                    return null;
                }
                var d = str.replace(/;/g, '').replace(/,\s+/g, ',').split(/\s+/g);
                var prev = prevData[i];
                return ({ key: prev ? prev.key : getRandomKey(), name: d[0], duration: d[1], ease: d[2], delay: d[3] });
            }).filter(function (c) { return c; });
            data = data.length ? data : [{ key: getRandomKey() }];
            return data;
        };
        _this.getChildren = function () { return (_this.state.data.map(function (data, i) { return ((React.createElement(Row, { gutter: 8, key: data.key },
            React.createElement(Col, { span: 6 },
                React.createElement(SelectInput, { style: { width: '100%' }, value: data.name || '', size: "small", onChange: function (e) {
                        _this.onChange('name', i, e);
                    } }, getOptionArray(nameSource))),
            React.createElement(Col, { span: 5 },
                React.createElement(AutoComplete, { dataSource: ['s', 'ms'], style: { width: '100%' }, value: data.duration || '', onChange: function (e) {
                        _this.onChange('duration', i, e);
                    } })),
            React.createElement(Col, { span: 6 },
                React.createElement(SelectInput, { style: { width: '100%' }, value: data.ease || '', dropdownStyle: { width: 104 }, onChange: function (e) {
                        _this.onChange('ease', i, e);
                    } }, getOption(easeSource))),
            React.createElement(Col, { span: 5 },
                React.createElement(AutoComplete, { dataSource: ['s', 'ms'], style: { width: '100%' }, value: data.delay || '', placement: "bottomRight", onChange: function (e) {
                        _this.onChange('delay', i, e);
                    } })),
            React.createElement(Col, { span: 2 },
                React.createElement("div", { onClick: function () {
                        _this.removeClick(i);
                    }, className: "icon-button" },
                    React.createElement(Icon, { type: "close-circle" })))))); })); };
        _this.removeClick = function (i) {
            var data = _this.state.data;
            data.splice(i, 1);
            _this.setData(data);
        };
        _this.state = {
            data: _this.getStateData(props),
            getStateData: _this.getStateData,
        };
        return _this;
    }
    EditorTransition.getDerivedStateFromProps = function (props, _a) {
        var prevProps = _a.prevProps, getStateData = _a.getStateData, prevData = _a.data;
        var nextState = {
            prevProps: props,
        };
        if (prevProps && prevProps.value !== props.value) {
            nextState.data = getStateData(props, prevData);
        }
        return nextState;
    };
    EditorTransition.prototype.render = function () {
        var _a = this.props, locale = _a.locale, value = _a.value, props = __rest(_a, ["locale", "value"]);
        return (React.createElement(Panel, __assign({}, props, { header: props.header || locale.header }),
            React.createElement(Row, { gutter: 8 },
                React.createElement(Col, { span: 6 }, locale.name),
                React.createElement(Col, { span: 5 }, locale.time),
                React.createElement(Col, { span: 6 }, locale.ease),
                React.createElement(Col, { span: 5 }, locale.delay)),
            React.createElement(TweenOneGroup, { appear: false, enter: {
                    height: 0,
                    marginBottom: 0,
                    opacity: 0,
                    type: 'from',
                    duration: 300,
                    ease: 'easeOutCirc',
                }, leave: { height: 0, marginBottom: 0, opacity: 0, duration: 300, ease: 'easeOutCirc' }, className: "editor-transition-tween" }, this.getChildren()),
            React.createElement("a", { onClick: this.onClick, className: "add-button" },
                React.createElement(Icon, { type: "plus" }))));
    };
    EditorTransition.propTypes = {
        value: PropTypes.string,
        onChange: PropTypes.func,
        header: PropTypes.string,
        locale: PropTypes.object,
    };
    EditorTransition.defaultProps = {
        value: '',
        onChange: function () { },
    };
    return EditorTransition;
}(Component));
EditorTransition.componentName = 'EditorTransition';
export default polyfill(EditorTransition);
